import React from 'react';
import { Star } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
export function Testimonios() {
  const testimonios = [{
    name: 'Juan',
    age: 34,
    city: 'Buenos Aires',
    img: 'https://i.pravatar.cc/150?img=11',
    quote: 'Desde que apliqué el tomo de posicionamiento, mi compañero y yo ganamos el torneo de 7ma. Increíble lo que cambia estar bien parado.'
  }, {
    name: 'Diego',
    age: 41,
    city: 'Rosario',
    img: 'https://i.pravatar.cc/150?img=15',
    quote: 'No tengo plata para pagar un profesor todas las semanas. Este pack me dio las herramientas que necesitaba para mejorar mi técnica.'
  }, {
    name: 'Pablo',
    age: 31,
    city: 'La Plata',
    img: 'https://i.pravatar.cc/150?img=53',
    quote: 'Me sentía estancado hace meses. Apliqué el plan de 30 días y mi juego dio un salto de calidad tremendo. Ahora juego mucho más seguro.'
  }];
  return <section className="py-14 bg-court-gradient relative border-t border-white/5" data-id="element-249">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-250">
        <FadeIn data-id="element-251">
          <h2 className="font-display text-3xl md:text-4xl font-bold text-center mb-10 uppercase" data-id="element-252">
            Lo que dicen <span className="text-neon" data-id="element-253">nuestros jugadores</span>
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-5" data-id="element-254">
          {testimonios.map((test, idx) => <FadeIn key={idx} delay={idx * 0.1} data-id="element-255">
              <div className="bg-padel-dark border border-white/10 p-6 rounded-2xl h-full flex flex-col relative" data-id="element-256">
                <div className="flex text-neon mb-3" data-id="element-257">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-258" />)}
                </div>
                <p className="text-gray-300 italic mb-5 flex-grow text-sm" data-id="element-259">
                  "{test.quote}"
                </p>
                <div className="flex items-center gap-3 mt-auto" data-id="element-260">
                  <img src={test.img} alt={test.name} className="w-11 h-11 rounded-full border-2 border-neon/50" data-id="element-261" />
                  <div data-id="element-262">
                    <h4 className="font-bold text-white text-sm" data-id="element-263">
                      {test.name}, {test.age}
                    </h4>
                    <p className="text-xs text-gray-400" data-id="element-264">{test.city}</p>
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}